import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-stopwatch",
  templateUrl: "./med-icon-stopwatch.component.html",
})
export class MedIconStopwatchComponent extends SvgMixinComponent {}
